<template>
    <svg 
        class="caret-icon" 
        :class="{ 'is-open': open }"
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink" 
        width="14" 
        height="8"
        viewBox="0 0 14 8"
    >
        <path fill="none" :stroke="colour" stroke-width="1.5" stroke-miterlimit="10" transform="translate(0.508789 0.551025)" d="M0 0L6.5 6L13 0" fill-rule="evenodd"/>
    </svg>
</template>

<script>
import { defineComponent } from "vue";

    export default defineComponent({
        name: 'Caret',

        props: {
            colour: {
                type: String,
                default: '#233484'
            },
            open: {
                type: Boolean,
                default: false
            }
        }
    })
</script>

<style>
    .caret-icon {
        transition: transform 0.2s ease;
    }

    .caret-icon.is-open {
        transform: rotate(180deg);
    }
</style>